<template>
  <frontPage/>
  <div>
    <div v-if="loading">Loading...</div>
    <div v-else>
      <input type="text" class="search-bar" v-model="searchTerm" placeholder="Search by pool or event..." />

      <div class="result-list-container">
        <div class="result-list-box">
          <h3>Pools</h3>
          <div class="result-list-title">
            <div class="button1" @click="toggleSortOptions">Sort</div>
            <div v-if="showSortOptions" class="sort-options">
              <div class="button1" @click="sortSubmissions('newest')">Newest to Oldest</div><br>
              <div class="button1" @click="sortSubmissions('oldest')">Oldest to Newest</div><br>
              <div class="button1" @click="sortSubmissions('poolNumber')">Pool Number</div>
            </div>
          </div>
          <div v-for="submission in sortedSubmissions" :key="submission._id" class="result-item">
            <input type="checkbox" :value="submission" v-model="selectedPools">
            <div class="result-info" @click="showSymbolPopup(submission)">
              <p class="result-name">{{ submission.DocumentName ? formatAddress(submission.DocumentName) : 'NA' }}</p>
              <p class="result-name">{{ submission.Timestamp ? submission.Timestamp : 'NA' }}</p>
            </div>
          </div>
        </div>

        <div class="result-list-box">
          <h3>Events</h3>
          <div class="result-list-title">
            <div class="button1" @click="toggleSortOptions">Sort</div>
          </div>
          <div v-for="event in filteredEvents" :key="event._id" class="result-item">
            <div class="result-info">
              <p class="result-name">{{ event.subjectAddress ? formatAddress(event.subjectAddress) : 'NA' }}</p>
            </div>
          </div>
        </div>

        <div class="result-list-box">
          <div class="result-list-title">
            <h3>Event Details</h3>
          </div>
        </div>
      </div>

      <div class="social-info-box">
        <h3>Social Info</h3>
        <div v-for="event in filteredEvents" :key="event._id" class="result-item">
          <div class="result-info">
            <a :href="`https://defibughunt.com/t/submissions-bot/11/${event.urlNumber}?u=mitchell_wo`" target="_blank" class="result-name">Link to Discousre thread on {{ event.DocumentName }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApolloClient, InMemoryCache, gql } from '@apollo/client/core';
import frontPage from './frontPage.vue';


export default {
  components: {
    frontPage
  },

  data() {
    return {
      loading: true,
      submissions: [],
      searchTerm: '',
      showPopup: false,
      selectedSubmission: null,
      sortOrder: 'ascending',
      showSortOptions: false,
      currentSort: 'newest',
      selectedPools: []
    };
  },
  async created() {
    try {
      const client = new ApolloClient({
        uri: 'https://glossi.fi/graphql',
        headers: {
          Authorization: 'Bearer your-token-here'
        },
        cache: new InMemoryCache(),
      });
      const query = gql`
        query {
          submissions {
            _id
            DocumentName
            Timestamp
            urlNumber
            subjectAddress
          }
        }
      `;
      const response = await client.query({ query });
      this.submissions = response.data.submissions;
      this.loading = false;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
  computed: {
    sortedSubmissions() {
      return this.filteredSubmissions.slice().sort((a, b) => {
        if (this.currentSort === 'newest') {
          return Number(b.Timestamp) - Number(a.Timestamp);
        } else if (this.currentSort === 'oldest') {
          return Number(a.Timestamp) - Number(b.Timestamp);
        }
      });
    },
    filteredEvents() {
      const selectedDocumentNames = this.selectedPools.map(pool => pool.DocumentName);
      return this.submissions.filter(submission =>
        selectedDocumentNames.includes(submission.DocumentName)
      );
    },
    filteredSubmissions() {
      const searchTermLower = this.searchTerm.toLowerCase();
      return this.submissions.filter(submission =>
        submission.DocumentName && submission.DocumentName.toLowerCase().includes(searchTermLower)
      );
    }
  },
  methods: {
    showSymbolPopup(submission) {
      this.selectedSubmission = submission;
    },
    toggleSortOptions() {
      this.showSortOptions = !this.showSortOptions;
    },
    sortSubmissions(option) {
      this.currentSort = option;
      this.showSortOptions = false;
    },
    formatAddress(address) {
      return address.length > 10 ? address.substring(0, 10) + '...' + address.slice(-5) : address;
    }
  }
};
</script>


<style scoped>
.result-item input[type="checkbox"] {
  /* Adjust scale as needed */
  margin-right: 10px; 
  transform-origin: center; 
  cursor: pointer; 
}
.button1 {
  padding: 10px 20px; /* Padding inside the button */
  background-color: #007BFF; /* Background color */
  color: white; /* Text color */
  text-align: center; /* Center the text inside the button */
  border-radius: 5px; /* Rounded corners */
  border: none; /* No border */
  cursor: pointer; /* Cursor changes to pointer to indicate it's clickable */
  transition: background-color 0.3s, transform 0.3s; /* Smooth transition for hover effects */
  display: inline-block; /* Make div behave like a button */
  font-weight: bold; /* Make the text bold */
  text-transform: uppercase; /* Uppercase text */
  letter-spacing: 1px; /* More spacing between letters */
  font-size: 14px; /* Font size */
}

.button1:hover {
  background-color: #0056b3; /* Darker background on hover */
  transform: translateY(-2px); /* Slight lift when hovered */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow effect for 3D feel */
}




.sort-options {
  position: absolute; /* or 'relative' depending on your layout */
  background: white;
  border: 1px solid #ddd;
  padding: 10px;
  z-index: 10;
}


.result-info,
.result-info p {
  text-decoration: none;
  /* Removes underline */
  color: black;
  /* Sets text color to black */
 
  /* Changes cursor to pointer to indicate it's clickable */
}

.router-link-active,
.router-link-exact-active,
.router-link-active .result-info,
.router-link-exact-active .result-info {
  text-decoration: none;
  color: black;
}

.search-bar {
  width: 100%;
  margin-top: 15px;
}

.result-list-container {
  display: flex;
  justify-content: center;
  width: 120%;
  margin-top: 70px;

}

.result-list-box {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  padding: 0px;
  width: 100%;

  justify-content: left;
  border-radius: 1%;
  height: 525px;
  overflow-y: auto;
}

.result-item {
  display: flex;
  align-items: center; /* Vertically centers the checkbox and text */
  margin-bottom: 10px; /* Adds some space between items */
}
.result-info {
  cursor: pointer;
}

.result-name {
  font-weight: bold;
  color: #777;
}

.result-address {
  margin-top: 5px;
  color: #777;
}





input:hover {

  background-color: #c2baba;



}

input {
  width: 40%;
  /* adjust width as desired */
  height: 40px;
  /* adjust height as desired */
  padding: 0 20px;
  /* add padding as desired */
  border: none;
  /* remove border if desired */
  border-radius: 5px;
  /* add border radius to make it rounded */
  font-size: 20px;
  /* adjust font size as desired */
  font-family: 'Courier New', Courier, monospace;

}

.social-info-box {
    width: 113%; /* Ensures the box takes up the full width of its container */
    border: 1px solid #ccc; /* Adds a border for visibility */
    padding: 20px; /* Adds some padding inside the box */
    margin-top: 20px; /* Adds space between this box and whatever is above it */
    background-color: #f9f9f9; /* Light background for the box */
    border-radius: 5px;
  }

  .social-info-box h3 {
    margin-top: 0;
    color: #000000; /* Dark color for the header text */
  }

</style>

